import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FacilityService } from 'src/app/core/services/facility.service';

@Component({
  selector: 'app-dashboard-ad',
  templateUrl: './dashboard-ad.component.html',
  styleUrls: ['./dashboard-ad.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardAdComponent implements OnInit {

  cloudBasePath: string;
  dashboardCarouselItems: string[] = [];
  dashboardCarouselTitles = {digitalCoach: 'DIGITAL.COACH.DASHBOARD.AD.HEADER'};
  dashboardCarouselImages = {digitalCoach: '/Images/Image_SubscribeAd_DigitalCoach_Blue.png'};
  dashboardCarouselDescriptions = {digitalCoach: 'DIGITAL.COACH.DASHBOARD.AD.MSG'};
  dashboardCarouselButtonLinks = {digitalCoach: 'https://www.lifefitness.com/en-us/digital-coach'};
  currentSlide: string;

  @Input() digitalCoach: boolean;
  @Output() closeDashboardAd: EventEmitter<string> = new EventEmitter<string>(); 

  constructor(
    private _facilityService: FacilityService
  ) {}

  ngOnInit(): void {
    this.cloudBasePath = environment.cloudBasePath;
    this.digitalCoach && this.dashboardCarouselItems.push('digitalCoach');
    this.currentSlide = 'digitalCoach';
  }

  closeAd() {
    this.closeDashboardAd.emit(this.currentSlide);
  }

  onSlideEvent(event: any) {
    this.currentSlide = event.current;
  }

}
